import React from "react";
import ReactECharts from "echarts-for-react";
import { generateShades } from "../../../helpers/generateShades";
import { formatHoursToHm } from "../../../helpers/formatTime";

const DonutChart = ({ title = "Projects", data=[] , id }) => {


  const colors = generateShades("#6C5DD3", data.length);
  const chartOptions = {

    tooltip: {
      trigger: "item",
      formatter: (params) => 
        `${params.name}: ${formatHoursToHm(params.value)} (${params.percent}%)`,
    },
    series: [
      {
        type: "pie",
        radius: ["50%", "70%"], // Donut effect
        avoidLabelOverlap: false,
        // label: {
        //   show: true,
        //   position: "center",
        //   formatter: title,
        //   fontSize: 14,
        //   fontWeight: "bold",
        // },
        emphasis: {
          label: {
            show: true,
            fontSize: "16",
            fontWeight: "bold",
          },
        },
        labelLine: {
          show: false,
        },
        data: data.map((item, index) => ({
          value: item.value,
          name: item.name,
          itemStyle: { color: colors[index % colors.length] },
        })),
      },
    ],
  };

  return <ReactECharts id={id} option={chartOptions} style={{ height: 350 , width: '100%'}} />;
};

export default DonutChart;
